<template>
	<!-- eslint-disable max-len -->
	<div class="faq-container p-4 max-w-4xl mx-auto">
		<h1 class="text-2xl font-bold mb-6">FAQs</h1>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">SASL ONLINE</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(1, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How do a sign up for the course?
				</button>
				<div v-if="isOpen(1, 1)" class="px-4 py-3 bg-gray-100">
					<p>Simply on the Sign Up button and complete the registration form, and follow the prompts. Alternatively click <a href="/Register">here</a>.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(1, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How much does the online SASL course cost?
				</button>
				<div v-if="isOpen(1, 2)" class="px-4 py-3 bg-gray-100">
					<p>The course costs <b>R249</b>, for 3 months' access.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(1, 3)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Do I get a certificate for completing the course?
				</button>
				<div v-if="isOpen(1, 3)" class="px-4 py-3 bg-gray-100">
					<p>Yes, once completed, you will receive a certificate of completion.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(1, 4)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How long is my access to the online SASL course valid for?
				</button>
				<div v-if="isOpen(1, 4)" class="px-4 py-3 bg-gray-100">
					<p>The course comes with for 3 months' access from the date of purchase.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">DEAFINITION SASL DICTIONARY APP</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(2, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					What platforms is the App available on?
				</button>
				<div v-if="isOpen(2, 1)" class="px-4 py-3 bg-gray-100">
					<p>The Apple iStore, The Google Playstore and the Huawei AppGallery.</p>
					<div v-if="showDeviceStore('Apple')"><p><a href="https://apps.apple.com/us/app/sasl-deafinition/id1583012841?ign-mpt=uo%3D4"><img src="images/appstore_apple.png" alt="Apple iStore" /></a></p></div>
					<div v-if="showDeviceStore('Android')"><p><a href="https://play.google.com/store/apps/details?id=com.edeafmobile&gl=ZA&pli=1"><img src="images/appstore_google.png" alt="The Google Playstore" /></a></p></div>
					<div v-if="showDeviceStore('Huawei')"><p><a href="https://appgallery.huawei.com/#/app/C111921979"><img src="images/appstore_huawei.png" alt="The Huawei AppGallery" /></a></p></div>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(2, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How much does the App cost to download?
				</button>
				<div v-if="isOpen(2, 2)" class="px-4 py-3 bg-gray-100">
					<p>The App is free to download.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">DONATIONS</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(3, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Can Deafinition accept donations?
				</button>
				<div v-if="isOpen(3, 1)" class="px-4 py-3 bg-gray-100">
					<p>DEAFinition is a registered NPC and Public Benefit Organisation (PBO), so this means that yes, we can receive donations. We are also able to issue Section 18A certificates for any donations received, meaning that businesses who donate, bona fide amounts of cash or property don't have to pay tax on any donation.</p>
					<br>
					<p>Another benefit is that the Deaf community of South Africans reap the reward for your generosity.</p>
					<br>
					<p>For more information, or to make a donation please contact us directly on <a href="mailto:info@edeafinition.co.za">info@edeafinition.co.za</a>.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">INTERACTING WITH DEAF INDIVIDUALS AND THE COMMUNITY</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(4, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How can I communicate effectively with a Deaf person?
				</button>
				<div v-if="isOpen(4, 1)" class="px-4 py-3 bg-gray-100">
					<p>There are many ways that you can communicate with Deaf individuals, it starts off by understanding and respecting the Deaf person's preferred method of communication, and actively trying to use this. Most Deaf and hearing individuals find common ground and use various techniques or a combination that bests suits them.</p>
					<br>
					<p>These methods include:
						<ul>
							<li>Learning some basic SASL, and communicating through Sign Language</li>
							<li>Using an qualified SASL interpreter (this could be in person, or over a "call")</li>
							<li>Through the use of gestures</li>
							<li>By using a pen and paper, and writing it down</li>
							<li>Through text based applications such as WhatsApp, SMS or E-mail</li>
							<li>Some Deaf individuals can lip read, so through spoken word</li>
							<li>There is a Deafinition SASL Dictionary App, that can help show you the sign for over 10 000 words</li>
						</ul>
					</p>
					<br>
					<p>Remember to maintain eye contact, keep calm and keep trying.</p>

				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">PERSPECTIVES ON DEAFNESS</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(5, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Can all Deaf people learn to speak?
				</button>
				<div v-if="isOpen(5, 1)" class="px-4 py-3 bg-gray-100">
					<p>Not all Deaf people can learn to speak. Some Deaf people never learn to verbally speak, it often depends on if they attend speech therapy and the mode of communication they choose to use. For those who choose to be oral, learning to speak is a priority. For those who choose to use Sign Language, learning to speak is not a priority, as SASL becomes their primary means of communication.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(5, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How do Deaf persons learn to speak?
				</button>
				<div v-if="isOpen(5, 2)" class="px-4 py-3 bg-gray-100">
					<p>Some Deaf people are hard of hearing or became Deaf later in life, so they may have learned to speak before losing their hearing. They might continue to use their voice because that's how they were raised, or they find this as an easier form of communication when a person does not speak SASL.</p>
					<br>
					<p>Some Deaf people learn to speak through intensive speech therapy. Even if they can't hear, many Deaf individuals go through speech training to learn how to pronounce words by watching mouth shapes, feeling vibrations, and practicing with help. With this being done, some Deaf individuals can talk, but may sound different to their hearing colleagues, as they they can't hear how they sound, and change the way to sound the same as others in terms of pronunciation and accents. Assistive devices like hearing aids and cochlear implants can also help in the quest to attain clear speech.</p>
					<br>
					<p>Some Deaf individuals use their voice naturally, even if it's not clear or "perfect," many still try to use it as part of how they communicate. There are also many Deaf individuals who choose to not use their voices at all, even though they can talk.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(5, 3)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Do all Deaf people want to be "cured" of their deafness?
				</button>
				<div v-if="isOpen(5, 3)" class="px-4 py-3 bg-gray-100">
					<p>Deaf individuals have diverse views on deafness. Many embrace their identity and culture, while others may seek technologies like cochlear implants. The concept of "curing" deafness is subjective and varies from person to person.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(5, 4)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Why are terms like "deaf-mute" or "deaf and dumb" considered offensive?
				</button>
				<div v-if="isOpen(5, 4)" class="px-4 py-3 bg-gray-100">
					<p>Terms like "deaf-mute" or "deaf and dumb" are considered offensive because they are outdated, inaccurate, and carry negative connotations. Historically, these terms were used to describe Deaf individuals, implying they were incapable of communication or intelligence, which is far from true. Many Deaf people use sign language, spoken language, or other methods to communicate effectively, and their deafness does not impact cognitive ability.</p>
					<br>
					<p>The term "mute" inaccurately suggests a complete inability to speak, which doesn't apply to all Deaf individuals, as some can and do speak. "Dumb" is particularly derogatory, historically equating deafness with a lack of intelligence, reinforcing harmful stereotypes. These terms stem from a time when societal understanding of deafness was limited, often framing it as a deficiency rather than a cultural or experiential difference.</p>
					<br>
					<p>Modern language prefers person-first or identity-first terms like "Deaf person" or "Deaf individual". These reflect respect for the individual's identity and communication abilities and accurate representation. Using outdated terms disregards progress and can perpetuate stigma.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(5, 5)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Can Deaf people drive - and how do they respond to hooting or auditory cues?
				</button>
				<div v-if="isOpen(5, 5)" class="px-4 py-3 bg-gray-100">
					<p>Yes, Deaf people can drive. In many countries (including South Africa), Deaf individuals are legally permitted to obtain a driver's licence, as being Deaf does not impair the ability to operate a vehicle safely. Driving relies heavily on visual cues - traffic lights, road signs, and observing other vehicles - which Deaf drivers are able to use effectively. Studies show no significant difference in driving safety between Deaf and hearing drivers.</p>
					<br>
					<p>For auditory cues like hooting, sirens, or other sounds, Deaf drivers compensate with heightened visual awareness and adaptive strategies:</p>
					<br>
					<p>1. <b>Visual Scanning:</b> Deaf drivers often check their surroundings more frequently, using mirrors and peripheral vision to stay alert for unusual activity, like flashing lights from emergency vehicles.</p>
					<p>2. <b>Situational Awareness:</b> Deaf drivers may rely on contextual clues, like sudden changes in traffic flow or other drivers' behaviour, to suggest potential auditory warnings.</p>
					<p>3. <b>Technology:</b> Modern vehicles with features like lane departure warnings, blind-spot monitoring, or rearview cameras provide visual feedback, benefiting Deaf drivers.</p>
					<br>
					<p>Deaf people live their lives by using their <b>eyes</b>- they <b>see to "hear"</b> the world. Their vision becomes very sharp, and they notice things quickly. This strong visual awareness helps them when driving too.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">SIGN LANGUAGE</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(6, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					What is a sign name?
				</button>
				<div v-if="isOpen(6, 1)" class="px-4 py-3 bg-gray-100">
					<p>A Sign Name is a specific name given by a member of the Deaf Community. It reflects an individual's character, a mannerism they are known for, or an aspect of their physical appearance. It may also include the first letter of their name. No two people typically have the same Sign Name. While there may be many people in the world with the same written or spoken name, Sign Names are unique.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(6, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					If I know the Sign Language alphabet, can I communicate in Sign Language?
				</button>
				<div v-if="isOpen(6, 2)" class="px-4 py-3 bg-gray-100">
					<p>The Sign Language alphabet is a tiny part of Sign Language that is used as a bridge between signed and written language. Although it is helpful, the alphabet cannot be used as a substitute for real Signs. Deaf individuals generally use fingerspelling to spell out words that don't have Signs, the names of people or places, or for clarity.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(6, 3)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How long does it take to learn SASL?
				</button>
				<div v-if="isOpen(6, 3)" class="px-4 py-3 bg-gray-100">
					<p>It can take between 3 months to 3 years to gain a solid working skill in SASL. If practiced regularly and the student is open to learning new Signs and dialects, SASL can remain a lifelong learning experience.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(6, 4)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Are all Deaf individuals proficient in Sign Language?
				</button>
				<div v-if="isOpen(6, 4)" class="px-4 py-3 bg-gray-100">
					<p>No, not all Deaf individuals use Sign Language, and proficiency varies. Some may use other communication methods, such as lipreading or written communication, depending on factors like the age of onset of deafness and personal preferences.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(6, 5)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Is Sign Language the same everywhere/universal?
				</button>
				<div v-if="isOpen(6, 5)" class="px-4 py-3 bg-gray-100">
					<p>No, sign languages are distinct and vary globally. South African Sign Language (SASL) is used primarily in South Africa, and man other countries have their own sign languages, such as British Sign Language (BSL), American Sign Language (ASL) or Auslan in Australia. SASL also has a few different dialects. You can see differences based on where an individual learned to Sign.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">TECHNOLOGY AND ACCESSIBILITY</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(7, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					How do Deaf people enjoy music or movies?
				</button>
				<div v-if="isOpen(7, 1)" class="px-4 py-3 bg-gray-100">
					<p>Deaf individuals experience music through vibrations, visual cues, and sometimes by feeling the beat. Subtitles or Sign Language interpretation make movies accessible for Deaf audiences.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(7, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Are cochlear implants a "cure" for deafness?
				</button>
				<div v-if="isOpen(7, 2)" class="px-4 py-3 bg-gray-100">
					<p>Cochlear implants are not a cure for deafness but a technological intervention that can provide some individuals with access to sound. Opinions on cochlear implants vary within the Deaf community, and some individuals choose not to use them.</p>
				</div>
			</div>
		</div>

		<div class="mb-8">
			<h2 class="text-xl font-semibold mb-4">UNDERSTANDING DEAFNESS AND COMMUNICATION</h2>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(8, 1)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Are all Deaf people part of the same community?
				</button>
				<div v-if="isOpen(8, 1)" class="px-4 py-3 bg-gray-100">
					<p>Deaf individuals may share common experiences but come from diverse backgrounds. Some Deaf people identify strongly with Deaf culture, while others may not. The degree of connection to the Deaf community varies.</p>
				</div>
			</div>

			<div class="mb-4 border rounded overflow-hidden">
				<button @click="toggle(8, 2)" class="w-full text-left px-4 py-2 bg-primary-800 text-white hover:bg-yellow-600 font-medium">
					Do all Deaf people read lips?
				</button>
				<div v-if="isOpen(8, 2)" class="px-4 py-3 bg-gray-100">
					<p>Not all Deaf individuals rely on lipreading, and its effectiveness varies. Lipreading can be challenging and is influenced by factors such as the speaker's clarity, environment, and the individual's proficiency in lipreading.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FAQMain',
	data() {
		return {
			openQuestions: {}
		};
	},
	methods: {
		toggle(section, index) {
			const key = `${section}-${index}`;
			this.openQuestions[key] = !this.openQuestions[key];
		},
		isOpen(section, index) {
			return this.openQuestions[`${section}-${index}`];
		},
		showDeviceStore(device) {
			if (device === 'Android' && navigator.userAgent.match(/Android/i)) {
				return true;
			} else if (device === 'Apple' && navigator.userAgent.match(/iPhone/i)) {
				return true;
			} else if (device === 'Huawei' && navigator.userAgent.match(/ihuaweiPhone/i)) {
				return true;
			} else {
				return false;
			}
		}
	},
};
</script>
<style scoped>
	.faq-container h2 {
		border-bottom: 2px solid #ddd;
		padding-bottom: 0.25rem;
	}

	a:link {
	color: black;
	background-color: transparent;
	text-decoration: none;
	}

	a:visited {
	color: rgb(51, 51, 248);
	background-color: transparent;
	text-decoration: none;
	}

	a:hover {
	color: rgb(51, 51, 248);
	background-color: transparent;
	text-decoration: underline;
	}

	a:active {
	color: yellow;
	background-color: transparent;
	text-decoration: underline;
	}

	ul {
	list-style: none;
	margin-left: 0;
	padding-left: 0;
	}

	li {
	padding-left: 1em;
	text-indent: -1em;
	}

	li:before {
	content: "+";
	padding-right: 5px;
	}
</style>
